import { render, staticRenderFns } from "./WorkSelectedInfo.vue?vue&type=template&id=65f21f6a&scoped=true"
import script from "./WorkSelectedInfo.vue?vue&type=script&lang=js"
export * from "./WorkSelectedInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkSelectedInfo.vue?vue&type=style&index=0&id=65f21f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f21f6a",
  null
  
)

export default component.exports